

export default [
  { icon: 'mdi-view-dashboard-outline', name: 'dashboard.view', text: 'Dashboard', link: '/' },

  { icon: 'mdi-alert-circle-outline', name: 'incidencias.view', text: 'Incidencias Masivas', link: '/incidencias-masivas' },
  { icon: 'mdi-clipboard-check-multiple-outline', name: 'ordenes_trabajo.view', text: 'Órdenes de Trabajo', link: '/ordenes-trabajo' },

  {
    icon: 'mdi-headset', text: 'Atenciones', regex: /^\/(sofono|chatwoot|apps\/board|kanban)/,
    items: [
      { icon: 'mdi-note-multiple-outline', name: 'tickets.view', text: 'Tickets', link: '/apps/board', link2: '/kanban' },
      { icon: 'mdi-phone-forward', name: 'sofonos.view', text: 'Soporte telefónico', link: '/sofono', counterKey: 'pre_sofonos_mios' },
      { icon: 'mdi-chat-processing-outline', name: 'chatwoot.view', text: 'Chat', link: '/chatwoot/conversaciones' },
    ]
  },

  { icon: 'mdi-inbox-multiple-outline', name: 'bandeja.view', text: 'Bandeja de Pendientes', link: '/bandeja', counterKey: 'bandeja_pendientes' },

  { icon: 'mdi-email-multiple-outline', name: 'email-log.view', text: 'Correos enviados', link: '/correos' },

  {
    icon: 'mdi-finance', text: 'Finanzas', regex: /^\/(facturacion|facturacion-compra|cobros|cobrar-notas|transferencia-electronica|webpay|devoluciones|proveedores-internacionales)/,
    items: [
      {
        icon: 'mdi-text-box-multiple-outline', text: 'Facturación Venta', regex: /^\/facturacion[^-]/,
        items: [
          { icon: 'mdi-receipt', name: 'facturacion.view', text: 'Facturar Notas de Cobro', link: '/facturacion', counterKey: 'facturas_pendientes_emision' },
          { icon: 'mdi-credit-card-outline', name: 'facturacion-credito.view', text: 'Facturar a Crédito', link: '/facturacion-credito', counterKey: 'facturas_credito_pendientes_emision' },
          { icon: 'mdi-history', name: 'facturacion.view', text: 'Historial de Facturas', regex: /^\/facturas-emitidas/, link: '/facturas-emitidas' },
          { icon: 'mdi-file-document-multiple-outline', name: 'facturacion.view', text: 'Folios (CAF)', regex: /^\/facturacion-folios/, link: '/facturacion-folios' },
          { icon: 'mdi-xml', name: 'facturacion.ver_xml', text: 'Visualizar XML', link: '/visualizar-xml' },
          { icon: 'mdi-file-chart-outline', name: 'facturacion.export_iempresario', text: 'Export iEmpresario', regex: /^\/export-iempresario/, link: '/export-iempresario' }
        ]
      },
      {
        icon: 'mdi-cash-multiple', text: 'Gestión de Cobros', regex: /^\/(cobros|cobrar-notas)/,
        items: [
          { icon: 'mdi-cash-check', name: 'cobros.view', text: 'Cobros de Facturas', link: '/cobros' },
          { icon: 'mdi-cash-multiple', name: 'cobros.view', text: 'Cobros de Notas', link: '/cobrar-notas' },
        ]
      },
      {
        icon: 'mdi-tag-text-outline', text: 'Facturación Compra', regex: /^\/facturacion-compra/,
        items: [
          { icon: 'mdi-truck-outline', name: 'compras.view', text: 'Proveedores', link: '/facturacion-compra-providers' },
          { icon: 'mdi-inbox-arrow-down-outline', name: 'compras.view', text: 'Facturas Recibidas', link: '/facturacion-compra-manage-dte' },
          { icon: 'mdi-bank-transfer-out', name: 'compras.view', text: 'Pagos Masivos', link: '/facturacion-compra-trasferencia' },

        ]
      },
      {
        icon: 'mdi-swap-horizontal', text: 'Transacciones', regex: /^\/(transferencia-electronica|webpay|devoluciones)/,
        items: [
          { icon: 'mdi-bank-transfer', name: 'pago-manual.view', text: 'Pagos Manuales', link: '/transferencia-electronica' },
          { icon: 'mdi-credit-card-outline', name: 'transacciones-webpay.view', text: 'Webpay', link: '/webpay' },
          { icon: 'mdi-cash-refund', name: 'devoluciones.view', text: 'Devoluciones Cliente', link: '/devoluciones' },
        ]
      },
      {
        icon: 'mdi-server-network', text: 'Proveedores Internacionales', regex: /^\/proveedores-internacionales/,
        items: [
          { icon: 'mdi-view-dashboard-outline', name: 'proveedores-internacionales.view', text: 'Dashboard', regex: /^\/proveedores-internacionales\/panel/, link: '/proveedores-internacionales/panel' },
          { icon: 'mdi-format-list-bulleted', name: 'proveedores-internacionales.view', text: 'Proveedores', regex: /^\/proveedores-internacionales\/listado/, link: '/proveedores-internacionales/listado' },
          { icon: 'mdi-clipboard-list-outline', name: 'proveedores-internacionales.view', text: 'Tareas', regex: /^\/proveedores-internacionales\/tareas/, link: '/proveedores-internacionales/tareas' },
        ]
      }
    ]
  },


  {
    icon: 'mdi-note-text-outline', text: 'Notas de cobro', regex: /^\/notas-cobro/,
    items: [

      { icon: 'mdi mdi-note-outline', name: 'notas-cobro.view', text: 'Emitir Nota', link: '/notas-cobro-generar' },
      { icon: 'mdi mdi-note-outline', name: 'notas-cobro.view', text: 'Emitidas', link: '/notas-cobros' },
      { icon: 'mdi mdi-note-search-outline', name: 'notas-cobro.view', text: 'No Generadas', link: '/notas-cobro/no-generadas', counterKey: 'notas_cobro_no_generadas' },
    ]
  },

  { icon: 'mdi-file-document-edit-outline', name: 'cotizaciones.view', text: 'Cotizaciones', link: '/cotizaciones' },

  {
    icon: 'mdi-cog-outline', text: 'Mantenedores', regex: /^\/(clients|clientes|users|roles|coupons|mantenedor|planes-servicios|categorias|campos-servicio|api-tokens|servidores|contratos|automatizaciones)/,
    items: [

      // Oculto temporalmente (reversible: descomentar para restaurar).
      // { icon: 'mdi-account-tie', name: 'clientes.view', text: 'Clientes', link: '/clients' },
      { icon: 'mdi-account-plus-outline', name: 'clientes.create', text: 'Crear Cliente', link: '/clientes/crear' },
      { icon: 'mdi-account', name: 'usuarios.view', text: 'Usuarios', link: '/users' },
      { icon: 'mdi-account-multiple-check', name: 'configuracion.roles-view', text: 'Roles y permisos', link: '/roles' },
      { icon: 'mdi mdi-ticket-percent', name: 'configuracion.roles-view', text: 'Cupones', link: '/coupons' },
      { icon: 'mdi-email-edit-outline', name: 'mantenedor-template.view', text: 'Templates de Correo', link: '/mantenedor/templates' },
      { icon: 'mdi-email-off-outline', name: 'mantenedor-mail-filtros.view', text: 'Filtros de Correo', link: '/mantenedor/filtros-correo' },
      { icon: 'mdi-layers-triple-outline', name: 'planes.view', text: 'Planes de Servicios', link: '/planes-servicios' },
      { icon: 'mdi-tag-multiple-outline', name: 'categorias.view', text: 'Categorías', link: '/categorias' },
      { icon: 'mdi-format-list-checks', name: 'planes.view', text: 'Campos de Servicio', link: '/campos-servicio' },
      { icon: 'mdi-key-variant', name: 'api-tokens.view', text: 'API Tokens', link: '/api-tokens' },
      { icon: 'mdi-server', name: 'mantenedor-servidor.view', text: 'Servidores', link: '/servidores' },
      { icon: 'mdi-dns-outline', name: 'ns-mx.view', text: 'NS / MX de Dominios', link: '/mantenedor/ns-mx' },
      { icon: 'mdi-office-building-cog-outline', name: 'mantenedor-datacenter.view', text: 'Datacenters', link: '/mantenedor/datacenters' },
      { icon: 'mdi-snowflake', name: 'mantenedor-aire-acondicionado.view', text: 'Aire Acondicionado', link: '/mantenedor/aire-acondicionado' },
      { icon: 'mdi-domain', name: 'mantenedor-departamento.view', text: 'Departamentos', link: '/mantenedor/departamentos' },
      { icon: 'mdi-text-box-edit-outline', name: 'mantenedor-textos-ticket.view', text: 'Textos de Tickets', link: '/mantenedor/textos-ticket' },
      { icon: 'mdi-calendar-clock', name: 'planes.view', text: 'Periodicidades', link: '/mantenedor/periodicidades' },
      { icon: 'mdi-cash-multiple', name: 'mantenedor-tarifas-manage2.view', text: 'Tarifas Manage2', link: '/mantenedor/tarifas-manage2' },
      { icon: 'mdi-file-document-outline', name: 'contratos.view', text: 'Contratos', link: '/contratos' },
      { icon: 'mdi-cog-sync-outline', name: 'automatizaciones.view', text: 'Automatizaciones', link: '/automatizaciones' },
    ]
  },
  { icon: 'mdi-check-circle', name: 'habilitation.view', text: 'Habilitaciones', link: '/apps/servicios/padres', regex: /^\/apps\/servicios/ },
  { icon: 'mdi-account-supervisor-outline', name: 'clientes-administrados.view', text: 'Clientes Administrados', link: '/clientes-administrados' },
  // Oculto a pedido del equipo: la entrada "Dashboard Cliente" no debe mostrarse en el menú lateral.
  // { icon: 'mdi-dns', name: 'habilitation.view', text: 'Dashboard Cliente', link: '/dashboardClient_search' },
  { icon: 'mdi-account-tie', name: 'habilitation.view', text: 'Clientes', link: '/resumen-cliente' },

  {
    icon: 'mdi-office-building-outline', text: 'Datacenter', regex: /^\/(datacenter|acceso-ip-internacional-temporal|smtp-temporal|smtp-poolname|redes)/,
    items: [
      // Badge = solicitudes por aprobar + personas actualmente dentro. Las
      // primeras pueden llegar desde el portal del cliente, sin que haya un
      // operador presente que avise al supervisor.
      { icon: 'mdi-badge-account-horizontal-outline', name: 'visitas-datacenter.view', text: 'Visitas', link: '/datacenter/visitas', counterKeys: ['visitas_datacenter_pendientes', 'personas_en_datacenter', 'visitas_datacenter_vencidas'] },
      // Badge = equipos con una alerta de falla abierta: el módulo queda
      // marcado hasta que mantención (o el operador) la resuelve.
      { icon: 'mdi-snowflake', name: 'aire-acondicionado.view', text: 'Aire Acondicionado', link: '/datacenter/aire-acondicionado', regex: /^\/datacenter\/aire-acondicionado/, counterKeys: ['aire_equipos_en_falla'] },
      {
        icon: 'mdi-lan', text: 'Redes', regex: /^\/(acceso-ip-internacional-temporal|smtp-temporal|smtp-poolname|redes)/,
        items: [
          { icon: 'mdi-ip-network-outline', name: 'redes.view', text: 'IP temporales', link: '/acceso-ip-internacional-temporal' },
          { icon: 'mdi-email-outline', name: 'redes.view', text: 'SMTP temporal', link: '/smtp-temporal' },
          { icon: 'mdi-dns', name: 'redes.view', text: 'SMTP poolname', link: '/smtp-poolname' },
          { icon: 'mdi-shield-lock-outline', name: 'redes.view', text: 'Gestión de políticas', link: '/redes/gestion-politicas' }
        ]
      },
    ]
  },

]
